/**
 * Language codes used in the application
 */
export enum LanguageCode {
  En = 'en',
  No = 'no',
  Sv = 'sv',
  Sw = 'sw',
  Es = 'es',
  Fr = 'fr',
  Cs = 'cs',
  Da = 'da',
  De = 'de',
  It = 'it',
}

/**
 * Surface label mappings by language
 * Maps each language to its table and court labels
 */
export interface SurfaceLabelMap {
  table: string;
  tables: string;
  court: string;
  courts: string;
}

/**
 * Surface labels for each supported language
 */
export const SurfaceLabelByLang: Record<LanguageCode, SurfaceLabelMap> = {
  [LanguageCode.En]: {
    table: 'table',
    tables: 'tables',
    court: 'court',
    courts: 'courts',
  },
  [LanguageCode.No]: {
    table: 'bord',
    tables: 'bord',
    court: 'bane',
    courts: 'baner',
  },
  [LanguageCode.Sv]: {
    table: 'bord',
    tables: 'bord',
    court: 'bana',
    courts: 'banor',
  },
  [LanguageCode.Sw]: {
    table: 'bord',
    tables: 'bord',
    court: 'bana',
    courts: 'banor',
  },
  [LanguageCode.Es]: {
    table: 'mesa',
    tables: 'mesas',
    court: 'pista',
    courts: 'pistas',
  },
  [LanguageCode.Fr]: {
    table: 'table',
    tables: 'tables',
    court: 'court',
    courts: 'cours',
  },
  [LanguageCode.Cs]: {
    table: 'stůl',
    tables: 'stoly',
    court: 'kurt',
    courts: 'kurty',
  },
  [LanguageCode.Da]: {
    table: 'bord',
    tables: 'borde',
    court: 'bane',
    courts: 'baner',
  },
  [LanguageCode.De]: {
    table: 'tisch',
    tables: 'tische',
    court: 'Platz',
    courts: 'Canchas',
  },
  [LanguageCode.It]: {
    table: 'tavolo',
    tables: 'tavoli',
    court: 'Campo',
    courts: 'Campi',
  },

};

